// extracted by mini-css-extract-plugin
export default {"withdraw_container":"Withdraw_withdraw_container__WACBx","withdraw_inner":"Withdraw_withdraw_inner__bt4no","header":"Withdraw_header__sWIOS","payment":"Withdraw_payment__UY97S"};